import axios from "axios";

const productsHttp = axios.create({
  baseURL: process.env.REACT_APP_API_PRODUCTS_URL,
});

export { productsHttp };
